module.exports = __webpack_public_path__ + "media/images/icons/create-venue-disabled-8515b07aacf9f22518e9cbff51cb216e.svg";